import { create } from 'zustand'

interface LayoutState {
    sidebarCollapsed: boolean
}

interface LayoutActions {
    toggleSidebar: () => void
    setSidebarCollapsed: (collapsed: boolean) => void
}

export type LayoutStore = LayoutState & LayoutActions

export const useLayoutStore = create<LayoutStore>((set) => ({
    sidebarCollapsed: false,
    toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
    setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
}))
